var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:_vm.$attrs.class,on:{"click":function($event){return _vm.$emit('switch')}}},[_c('FiltersIcon'),_c('p',{staticClass:"text"},[_vm._v("Filters")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }